export default "__VITE_ASSET__BLqfc5Eo__"